<template>
  <div class="dashboard-editor-container">
    <el-form ref="queryForm" :model="queryParams" :inline="true" onsubmit="return false">
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          size="mini"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini" @click="handleQuery">查询</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="12" style="margin:10px 0px">
      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserAnalyze" title="今日新增" :total="dayStat.reg_count | scientificFormat" :contrast="dayStat.reg_count > dayStat.yesterday_reg_count">
          <template slot="content">
            今日 安卓:{{ dayStat.android_reg_count }} 苹果:{{ dayStat.ios_reg_count }} <br>
            昨日 安卓:{{ dayStat.yesterday_android_reg_count }} 苹果:{{ dayStat.yesterday_ios_reg_count }}
          </template>
          <template slot="footer">昨日新增<span> {{ dayStat.yesterday_reg_count | scientificFormat }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserAnalyze" title="今日活跃" :total="dayStat.log_count | scientificFormat" :contrast="dayStat.log_count > dayStat.yesterday_log_count">
          <div />
          <template slot="footer">昨日活跃<span> {{ dayStat.yesterday_log_count | scientificFormat }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserSpins#userAvg" title="今日人均时长(分钟)" :total=" dayStat.avg_online | scientificFormat" :contrast="dayStat.avg_online > dayStat.yesterday_avg_online">
          <div />
          <template slot="footer">昨日人均时长(分钟)<span> {{ dayStat.yesterday_avg_online | scientificFormat }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card title="今日邀请占比" :total="dayStat.invite_reg_rate+'%'" :flag="false">
          <template slot="content">今日邀请人数:{{ dayStat.invite_reg }}<br> 昨日邀请人数:{{ dayStat.yesterday_invite_reg }}</template>
          <template slot="footer">昨日邀请占比<span> {{ dayStat.yesterday_invite_reg_rate }}%</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card title="今日自然量占比" :total="dayStat.user_naturally_rate+'%'" :flag="false">
          <template slot="content">今日自然人数:{{ dayStat.user_naturally }}<br> 昨日自然人数:{{ dayStat.yesterday_user_naturally }}</template>
          <template slot="footer">昨日自然量占比<span> {{ dayStat.yesterday_user_naturally_rate }}%</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserOnline" title="当前在线" :total=" dayStat.online_count | scientificFormat" :contrast="dayStat.avg_online > dayStat.yesterday_avg_online">
          <div />
          <template slot="footer">用户总量<span> {{ dayStat.total_user_count | scientificFormat }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserPayStat" title="今日付费" :total=" dayStat.pay_price | scientificFormat | addToField1" :contrast="dayStat.pay_price > dayStat.yesterday_pay_price">
          <template slot="content">
            安卓:${{ dayStat.android_pay_price }} 苹果:${{ dayStat.ios_pay_price }} vip:${{ dayStat.confirm_sub_vip_price }}<br>
            <!--            昨日 安卓:{{ dayStat.yesterday_android_pay_price }} 苹果:{{ dayStat.yesterday_ios_pay_price }}  vip:{{ dayStat.yesterday_sub_vip_price }}-->
          </template>
          <template slot="footer">昨日付费<span> {{ dayStat.yesterday_pay_price | scientificFormat | addToField1 }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserPayStat" title="今日用户首次付费" :total=" dayStat.first_pay_price | scientificFormat | addToField1" :contrast="dayStat.first_pay_price > dayStat.yesterday_first_pay_price">
          <template slot="footer">昨日用户首次付费<span> {{ dayStat.yesterday_first_pay_price | scientificFormat | addToField1 }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="Order" title="今日订阅Vip人数" :total=" dayStat.sub_vip_count | scientificFormat" :contrast="dayStat.sub_vip_count > dayStat.yesterday_sub_vip_count">
          <template slot="content">
            今日确认 金额:${{ dayStat.confirm_sub_vip_price }}  人数:{{ dayStat.confirm_sub_vip_count }}<br>
            今日已取消 人数:{{ dayStat.cancel_sub_vip_count }}<br>
          </template>
          <template slot="footer">昨日订阅Vip人数<span> {{ dayStat.yesterday_sub_vip_count | scientificFormat }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserPayStat" title="今日注册付费人数" :total=" dayStat.reg_pay_user_count | scientificFormat" :contrast="dayStat.reg_pay_user_count > dayStat.yesterday_reg_pay_user_count">
          <div />
          <template slot="footer">昨日注册付费人数<span> {{ dayStat.yesterday_reg_pay_user_count | scientificFormat }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserPayStat" title="今日用户首次付费人数" :total=" dayStat.first_pay_user_count | scientificFormat" :contrast="dayStat.first_pay_user_count > dayStat.yesterday_first_pay_user_count">
          <div />
          <template slot="footer">昨日用户首次付费人数<span> {{ dayStat.yesterday_first_pay_user_count | scientificFormat }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserPayStat" title="今日活跃付费人数" :total=" dayStat.log_pay_user_count | scientificFormat" :contrast="dayStat.log_pay_user_count > dayStat.yesterday_log_pay_user_count">
          <div />
          <template slot="footer">昨日活跃付费人数<span> {{ dayStat.yesterday_log_pay_user_count | scientificFormat }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserPayStat" title="今日付费率" :total=" numberFixed(dayStat.pay_rate) | scientificFormat | addToField2" :contrast="dayStat.pay_rate > dayStat.yesterday_pay_rate">
          <div />
          <template slot="footer">昨日付费率<span> {{ numberFixed(dayStat.yesterday_pay_rate) | scientificFormat | addToField2 }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserPayStat" title="今日注册付费率" :total=" numberFixed(dayStat.reg_pay_rate) | scientificFormat | addToField2" :contrast="dayStat.reg_pay_rate > dayStat.yesterday_reg_pay_rate">
          <div />
          <template slot="footer">昨日注册付费率<span> {{ numberFixed(dayStat.yesterday_reg_pay_rate) | scientificFormat | addToField2 }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserPayStat" title="今日活跃付费率" :total=" numberFixed(dayStat.login_pay_rate) | scientificFormat | addToField2" :contrast="dayStat.login_pay_rate > dayStat.yesterday_login_pay_rate">
          <div />
          <template slot="footer">昨日活跃付费率<span> {{ numberFixed(dayStat.yesterday_login_pay_rate) | scientificFormat | addToField2 }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserPayStat" title="ARPU" :total=" numberFixed(dayStat.arpu) | scientificFormat | addToField1" :contrast="dayStat.arpu > dayStat.yesterday_arpu">
          <div />
          <template slot="footer">昨日ARPU<span> {{ numberFixed(dayStat.yesterday_arpu) | scientificFormat | addToField1 }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserPayStat" title="ARPPU" :total=" numberFixed(dayStat.arppu) | scientificFormat | addToField1" :contrast="dayStat.arppu > dayStat.yesterday_arppu">
          <div />
          <template slot="footer">昨日ARPPU<span> {{ numberFixed(dayStat.yesterday_arppu) | scientificFormat | addToField1 }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card title="本月累计流水" :total=" dayStat.monthPrice | scientificFormat | addToField1" :contrast="dayStat.monthPrice > dayStat.Yesterday_month_price">
          <template slot="footer"> 上月总流水<span> {{ dayStat.Yesterday_month_price | scientificFormat |addToField1 }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="ROI" title="今日投放花费" :total=" dayStat.adPrice | scientificFormat | addToField1" :flag="false">
          <div />
          <template slot="footer">昨日投放花费<span> {{ dayStat.yesterdayAdPrice | scientificFormat | addToField1 }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="ROI" title="今日广告安装" :total=" dayStat.adInstall | scientificFormat" :contrast="dayStat.adInstall > dayStat.yesterdayAdInstall">
          <div />
          <template slot="footer">昨日广告安装<span> {{ dayStat.yesterdayAdInstall | scientificFormat }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="ROI" title="CPI" :total=" dayStat.cpi | scientificFormat" :contrast="dayStat.cpi > dayStat.yesterdayCpi">
          <div />
          <template slot="footer">昨日CPI<span> {{ dayStat.yesterdayCpi | scientificFormat }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="UserPayStat" title="今日渠道后内购流水" :total=" dayStat.AdPayPrice | scientificFormat | addToField1" :contrast="dayStat.AdPayPrice > dayStat.yesterdayAdPayPrice">
          <div />
          <template slot="footer">昨日渠道后内购流水<span> {{ dayStat.yesterdayAdPayPrice | scientificFormat | addToField1 }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card link-url="ROI" title="ROI" :total=" dayStat.roi | scientificFormat " :contrast="dayStat.roi > dayStat.yesterdayRoi">
          <div />
          <template slot="footer">昨日ROI<span> {{ dayStat.yesterdayRoi | scientificFormat }}</span></template>
        </chart-card>
      </el-col>

      <el-col :sm="12" :xs="24" :md="4" :xl="4" :lg="4" :style="{ marginBottom: '12px' }">
        <chart-card title="当日盈亏" :total=" dayStat.profitLoss.toFixed(2) | scientificFormat | addToField1" :contrast="dayStat.profitLoss > dayStat.yesterdayProfitLoss">
          <div />
          <template slot="footer">昨日盈亏<span> {{ dayStat.yesterdayProfitLoss.toFixed(2) | scientificFormat | addToField1 }}</span></template>
        </chart-card>
      </el-col>

    </el-row>

    <el-row :gutter="12">
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <IndexUserCharts2 />
      </el-col>
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <UserOnline :show-table="false" />
      </el-col>
    </el-row>

    <el-row :gutter="12">
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <IndexUserDataAvg :is-export="false" />
      </el-col>
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <IndexUserMain />
      </el-col>
    </el-row>

    <el-row :gutter="12">
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <LoginRemain :is-show-table="false" />
      </el-col>
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <IndexUserPayAnalyze :table="false" />
      </el-col>
    </el-row>

    <el-row :gutter="12">
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <IndexVersion />
      </el-col>
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <IndexUserLoginAnalyze2 :table="false" />
      </el-col>
    </el-row>

    <el-row :gutter="12">
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <IndexPayData />
      </el-col>
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <PayUserRemain :is-show-table="false" />
      </el-col>
    </el-row>

    <el-row :gutter="12">
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <RegPayUserRemain :is-show-table="false" />
      </el-col>
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <IndexRegPay />
      </el-col>
    </el-row>

    <el-row :gutter="12">
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <PayLoginUserRemain :is-show-table="false" />
      </el-col>
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <IndexUserNotBuild :is-show-table="false" />
      </el-col>
    </el-row>

    <el-row :gutter="12">
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <IndexUseNetDepletionStat :is-show-table="false" />
      </el-col>
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <LoginEventStat :is-show-table="false" />
      </el-col>
    </el-row>

    <el-row :gutter="12">
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <ReportRateStat :is-show-table="false" />
      </el-col>
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <PayLevelStat echart-title="用户等级付费统计" :is-show-table="false" />
      </el-col>
    </el-row>
    <el-row :gutter="12">
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <IndexSubVip />
      </el-col>
      <el-col :sm="24" :xs="24" :md="12" :xl="12" :lg="12" :style="{ marginBottom: '12px' }">
        <IndexRealTimeCount />
      </el-col>
    </el-row>
    <initReward />
  </div>
</template>

<script>
import ChartCard from '@/components/ChartCard'
import initReward from '@/components/Reward/initReward.vue'
// import Trend from '@/components/Trend'
import IndexUserCharts2 from '@/components/Index/IndexUserCharts2.vue'
import IndexUserMain from '@/components/Index/IndexUserMain.vue'
// import IndexOnline from '@/components/Index/IndexOnline.vue'
// import IndexPayData from '@/components/Index/IndexPayData.vue'
import IndexPayData from '@/components/Index/IndexPayData.vue'
import { getDatStat } from '@/api/config/index'
import LoginRemain from '@/components/userRemain/LoginRemain.vue'
import IndexVersion from '@/components/Index/IndexVersion.vue'
import PayUserRemain from '@/components/Index/PayRemain.vue'
import RegPayUserRemain from '@/components/Index/RegPayRemain.vue'
import PayLoginUserRemain from '@/components/Index/PayLoginRemain.vue'
// import IndexUserOnlineAvg from '@/components/Index/IndexUserOnlineAvg.vue'
import IndexUserDataAvg from '@/components/Index/IndexUserDataAvg.vue'
import IndexRegPay from '@/components/Index/IndexRegPay.vue'
import IndexUserPayAnalyze from '@/components/Index/IndexUserPayAnalyze.vue'
// import IndexUserLoginAnalyze from '@/components/Index/IndexUserLoginAnalyze.vue'
import IndexUserLoginAnalyze2 from '@/components/Index/IndexUserLoginCountAnalyze.vue'
import IndexUserNotBuild from '@/components/Index/IndexUserNotBuildStat.vue'
import IndexUseNetDepletionStat from '@/components/Index/IndexUseNetDepletionStat.vue'
// import IndexUserOnlineAvg from '@/components/Index/IndexUserOnlineAvg.vue'
// import IndexOnline from '@/components/Index/IndexOnline.vue'
import UserOnline from '@/views/config/user-online/index.vue'
import PayLevelStat from '@/views/config/user-pay/components/pay_level.vue'
import LoginEventStat from '@/components/Index/IndexLoginEventStat.vue'
import ReportRateStat from '@/components/Index/IndexReportRate.vue'
import IndexSubVip from '@/components/Index/IndexSubVip.vue'
import IndexRealTimeCount from '@/components/Index/IndexRealTimeCount.vue'
require('echarts/theme/macarons') // echarts theme

// const barData = []
// const barData2 = []
// for (let i = 0; i < 12; i += 1) {
//   barData.push({
//     x: `${i + 1}月`,
//     y: Math.floor(Math.random() * 1000) + 200
//   })
//   barData2.push({
//     x: `${i + 1}月`,
//     y: Math.floor(Math.random() * 1000) + 200
//   })
// }

// const rankList = []
// for (let i = 0; i < 7; i++) {
//   rankList.push({
//     name: '白鹭岛 ' + (i + 1) + ' 号店',
//     total: 1234.56 - i * 100
//   })
// }

export default {
  name: 'DashboardAdmin',
  components: {
    IndexRealTimeCount,
    IndexSubVip,
    initReward,
    UserOnline,
    // IndexOnline,
    // IndexUserOnlineAvg,
    RegPayUserRemain,
    // IndexUserLoginAnalyze,
    IndexUserLoginAnalyze2,
    IndexUserPayAnalyze,
    ChartCard,
    PayLoginUserRemain,
    // Trend,
    // MiniArea,
    LoginRemain,
    // IndexPriceCharts,
    IndexUserCharts2,
    // IndexPayStat,
    // IndexFirstPayStat,
    IndexUserMain,
    // IndexOnline,
    IndexPayData,
    IndexVersion,
    // IndexUserOnlineAvg,
    PayUserRemain,
    IndexRegPay,
    IndexUserNotBuild,
    IndexUseNetDepletionStat,
    IndexUserDataAvg,
    LoginEventStat,
    ReportRateStat,
    PayLevelStat
  },
  filters: {
    addToField1(value) {
      return '$' + value
    },
    addToField2(value) {
      return value + '%'
    },
    scientificFormat(value) {
      if (value === 0) {
        return 0
      } else {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    }
  },
  data() {
    return {
      queryParams: {
        startDate: ''
      },
      // barData,
      // barData2,
      // rankList,
      indexLeft: {
        today_price: 0,
        week_on_week: 0,
        chain_reaction: 0,
        avg_price: 0,
        total: 0
      },
      loading: false,
      dayStat: {
        'date': '',
        'reg_count': 0,
        'yesterday_reg_count': 0,
        'total_user_count': 0,
        'yesterday_total_user_count': 0,
        'log_count': 0,
        'invite_reg': 0,
        'invite_reg_rate': 0,
        'yesterday_invite_reg': 0,
        'yesterday_invite_reg_rate': 0,
        'yesterday_log_count': 0,
        'first_pay': 0,
        'yesterday_first_pay': 0,
        'pay_user_count': 0,
        'yesterday_pay_user_count': 0,
        'reg_pay_user_count': 0,
        'yesterday_reg_pay_user_count': 0,
        'log_pay_user_count': 1,
        'yesterday_log_pay_user_count': 0,
        'pay_price': 0,
        'total_pay_price': 0,
        'yesterday_pay_price': 0,
        'total_pay_user': 0,
        'avg_online': 0,
        'yesterday_avg_online': 0,
        'total_order_count': 0,
        'order_count': 0,
        'user_naturally': 0,
        'user_naturally_rate': 0,
        'yesterday_user_naturally': 0,
        'yesterday_user_naturally_rate': 0,
        'adInstall': 0,
        'online_count': 3,
        'pay_rate': 0,
        'reg_pay_rate': 0,
        'yesterday_reg_pay_rate': 0,
        'login_pay_rate': 0,
        'yesterday_login_pay_rate': 0,
        'yesterday_pay_rate': 0,
        'arpu': 0,
        'yesterday_arpu': 0,
        'arppu': 0,
        'yesterday_arppu': 0,
        'next_day_remain1': 0,
        'next_day_remain2': 0,
        'adPrice': 0,
        'yesterdayAdPrice': 0,
        'yesterdayAdInstall': 0,
        'AdPayPrice': 0,
        'yesterdayAdPayPrice': 0,
        'cpi': 0,
        'yesterdayCpi': 0,
        'roi': 0,
        'yesterdayRoi': 0,
        'profitLoss': 0,
        'yesterdayProfitLoss': 0,
        'first_pay_user_count': 0,
        'yesterday_first_pay_user_count': 0,
        'first_pay_price': 0,
        'yesterday_first_pay_price': 0,
        'monthPrice': 0,
        'Yesterday_month_price': 0,
        'sub_vip_count': 0,
        'sub_vip_price': 0,
        'yesterday_vip_price': 0,
        'yesterday_sub_vip_count': 0,
        'android_reg_count': 0,
        'ios_reg_count': 0,
        'yesterday_android_reg_count': 0,
        'yesterday_ios_reg_count': 0,
        'android_pay_price': 0,
        'ios_pay_price': 0,
        'yesterday_android_pay_price': 0,
        'yesterday_ios_pay_price': 0,
        'confirm_sub_vip_count': 0,
        'confirm_sub_vip_price': 0,
        'cancel_sub_vip_price': 0,
        'cancel_sub_vip_count': 0,
        'yesterday_confirm_sub_vip_count': 0,
        'yesterday_confirm_sub_vip_price': 0,
        'yesterday_cancel_sub_vip_price': 0,
        'yesterday_cancel_sub_vip_count': 0
      }
    }
  },
  created() {
    this.getTable()
    // this.getDatStatis()
  },
  methods: {
    handleQuery() {
      this.getDatStatis()
    },
    numberFixed(val, num = 2) {
      if (val > 0) {
        return val.toFixed(num)
      }
      return val
    },
    getTable() {
      setTimeout(() => {
        this.getDatStatis()
      }, 1500)

      // setInterval(() => {
      //   this.getDatStatis()
      // }, 20000)
    },
    gindexLeft() {
      // getIndexLeft().then(res => {
      //   if (res.code === 200) {
      //     this.indexLeft.today_price = res.data.today_price
      //     this.indexLeft.week_on_week = (res.data.week_on_week).toString()
      //     this.indexLeft.chain_reaction = (res.data.chain_reaction).toString()
      //     this.indexLeft.avg_price = res.data.avg_price
      //     this.indexLeft.total = res.data.total
      //   } else {
      //     this.msgError(res.msg)
      //   }
      // })
    },
    getDatStatis() {
      this.loading = true
      getDatStat(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.dayStat = res.data.data
          this.queryParams.startDate = res.data.req.startDate
        } else {
          this.msgError(res.msg)
        }
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 12px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0;
    border: 0;
    right: 0;
  }

  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}

::v-deep .el-tabs__item{
   padding-left: 16px!important;
   height: 50px;
   line-height: 50px;
}

@media (max-width:1024px) {
  .chart-wrapper {
    padding: 8px;
  }
}
.user_add{
  font-size: 20px;
  font-weight: bold;
}
</style>
